<div class="img-wrapper p-6 flex justify-center items-center">
  <!-- image loading skeleton -->
  <div *ngIf="!loaded" class="animated-bg h-full w-full"></div>
  <!-- logoUrl image -->
  <img #img 
    [src]="src" 
    (load)="loaded = true"
    (error)="loaded = true"
    [class.hidden]="!loaded"
    [alt]="alt"
    class="img-card" 
  >
</div>
